import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/",
    component: () =>
      import(/* webpackChunkName: "WebLayout" */ "@/layouts/WebLayout.vue"),
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "/",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/HomeView.vue"),
        meta: {
          requiresAuth: false,
          title: "Home - Maipú Salud"
        }
      },
      {
        path: "/nosotros/quienes-somos",
        name: "QuienesSomos",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Menu/QuienesSomosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Quíenes Somos - Maipú Salud"
        }
      },
      {
        path: "/informacion-al-paciente",
        name: "InformacionPaciente",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Menu/InformacionPacienteView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Información al usuario - Maipú Salud"
        }
      },
      {
        path: "/prestaciones-de-salud-y-programas",
        name: "PrestacionSaludProgramas",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Menu/PrestacionSaludProgramasView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Prestaciones de Salud y Programas - Maipú Salud"
        }
      },
      {
        path: "/inscribete-en-tu-cesfam",
        name: "InscribeteCesfam",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Menu/InscribeteCesfamView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Busca tu Cesfam - Maipú Salud"
        }
      },
      {
        path: "/solicita-tu-atencion-de-salud",
        name: "SolicitaAtencion",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Municipalidad/SolicitaAtencionView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Solicita tu atención de salud - Maipú Salud"
        }
      },
      {
        path: "/telesalud",
        name: "Telesalud",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Municipalidad/TelesaludView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "TELESALUD - Maipú Salud"
        }
      },
      // {
      //   path: "/tramites-de-salud",
      //   name: "TramitesSalud",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "home" */ "@/views/Menu/TramitesSaludView.vue"
      //     ),
      //   meta: {
      //     requiresAuth: false,
      //     title: "Tramites de Salud - Maipú Salud"
      //   }
      // },
      {
        path: "/nuestra-red-de-salud-maipu",
        name: "NuestraRed",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Menu/NuestraRedView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Nuestra red de salud - Maipú Salud"
        }
      },
      {
        path: "/telefonos",
        name: "Telefonos",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Web/TelefonosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Teléfonos - Maipú Salud"
        }
      },
      {
        path: "/tramites-y-pagos-online",
        name: "Tramites",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/Web/TramitesView.vue"),
        meta: {
          requiresAuth: false,
          title: "Trámites y pagos online - Maipú Salud"
        }
      },
      {
        path: "/noticias",
        name: "Noticias",
        component: () =>
          import(
            /* webpackChunkName: "noticias" */ "@/views/Noticias/NoticiasView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Noticias - Maipú Salud"
        }
      },
      {
        path: "/noticias/publicacion/:nombre",
        name: "Publicacion",
        component: () =>
          import(
            /* webpackChunkName: "Publicacion" */ "@/views/Noticias/PublicacionView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Noticia - Maipú Salud"
        }
      },
      {
        path: "/contenido/noticias/preview/:nombre",
        name: "PublicacionPreview",
        component: () =>
          import(
            /* webpackChunkName: "PublicacionPreview" */ "@/views/Noticias/PublicacionPreviewView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Noticia Preview - Maipú Salud"
        }
      },
      {
        path: "/noticias/categoria/:nombre",
        name: "Categoria",
        component: () =>
          import(
            /* webpackChunkName: "Categoria" */ "@/views/Noticias/CategoriaView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Noticias"
        }
      },
      {
        path: "/comuna/:nombre",
        name: "Comuna",
        component: () =>
          import(
            /* webpackChunkName: "Comuna" */ "@/views/Comuna/GenericoView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Comuna"
        }
      },
      {
        path: "/municipalidad/:nombre",
        name: "Municipalidad",
        component: () =>
          import(
            /* webpackChunkName: "Municipalidad" */ "@/views/Municipalidad/GenericoView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Maipú Salud"
        }
      },
      {
        path: "/destacado/:nombre",
        name: "Destacado",
        component: () =>
          import(
            /* webpackChunkName: "Destacado" */ "@/views/Destacado/GenericoView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Destacado"
        }
      },
      {
        path: "/:nombre",
        name: "Pagina",
        component: () =>
          import(
            /* webpackChunkName: "Pagina" */ "@/views/Pagina/GenericoView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Maipú Salud"
        }
      },
      {
        path: "/contenido/pagina/preview/:nombre",
        name: "PaginaPreview",
        component: () =>
          import(
            /* webpackChunkName: "PaginaPreview" */ "@/views/Pagina/PreviewView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Preview Página"
        }
      },
      {
        path: "/contacto/formulario",
        name: "Contacto",
        component: () =>
          import(
            /* webpackChunkName: "Pagina" */ "@/views/Contacto/ContactoView.vue"
          ),
        meta: {
          title: "Formulario de Consultas - Maipú Salud"
        }
      },
      {
        path: "/concejo/municipal",
        name: "Concejo",
        component: () =>
          import(
            /* webpackChunkName: "Pagina" */ "@/views/Municipalidad/ConcejoView.vue"
          ),
        meta: {
          title: "Concejo Municipal - Maipú Salud"
        }
      },
      {
        path: "/organizaciones/ley-21146",
        name: "Organizaciones",
        component: () =>
          import(
            /* webpackChunkName: "Pagina" */ "@/views/Municipalidad/OrganizacionesView.vue"
          ),
        meta: {
          title: "Ley 21.146 - Maipú Salud"
        }
      },
      {
        path: "/omil/ofertas",
        name: "OfertasOmil",
        component: () =>
          import(
            /* webpackChunkName: "Pagina" */ "@/views/Web/OfertasOmilView.vue"
          ),
        meta: {
          title: "Ofertas Laborales OMIL - Maipú Salud"
        }
      },
      {
        path: "/category/noticia/",
        redirect: "/noticias"
      },
      { path: "/wp-content/*", redirect: "/" },
      { path: "/category/*", redirect: "/" },
      { path: "/tag/*", redirect: "/" }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
